<template>
  <div class="title-section">
    <div>
      <q-icon :name="icon" size="36pt"></q-icon>
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    label: String,
  },
};
</script>

<style>
.title-section {
  padding: 20pt;
  font-size: 175%;
  text-align: center;
  font-weight: bold;
  background: linear-gradient(335deg, #000000, #0d0f47);
  color: rgb(255 255 255 / 80%);
}
</style>
